export enum Resource {
  app = 'app',
  view = 'view',
  schema = 'schema',
  administration = 'administration',
  viewAdministration = 'viewAdministration',
  push = 'push',
  itemActionsMenu = 'itemActionsMenu',
  commentWidget = 'commentWidget',
  addNewItem = 'addNewItem',
  removeItem = 'removeItem',
  updateAudiences = 'updateAudiences',
  efsEdit = 'efsEdit',
  backtagWidget = 'backtagWidget'
}
